import { Box, Chip, SxProps, Theme, Typography } from '@mui/material';

import { LineInfo, LineInfoIcon } from './LineInfoIcon';
import { ScoopStatPill } from './types';

type LinePillsItemProps = Readonly<{
  title: string;
  pills: ScoopStatPill[];
  info?: LineInfo;
}>;

export const LinePillsItem = ({ title, pills, info }: LinePillsItemProps) => {
  const titleId = title.toLowerCase().replace(/\s+/g, '-');

  return (
    <Box sx={containerSx}>
      <Box sx={titleContainerSx}>
        <Typography variant="text-md-semibold" color={({ backrs }) => backrs.colors['Brand/500']}>
          {title}
        </Typography>
        {info && <LineInfoIcon info={info} idPrefix={`line-pills-${titleId}`} />}
      </Box>

      <Box sx={pillRowSx}>
        {pills.map((pill) => (
          <Chip
            key={pill.id}
            id={pill.id}
            variant="pill"
            size="md"
            type="leading"
            label={pill.label}
            sx={pillSx(!!pill.onClick)}
            clickable={!!pill.onClick}
            onClick={pill.onClick}
          />
        ))}
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-md'],
});

const titleContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

const pillRowSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: backrs.spacing['spacing-sm'],
});

const pillSx =
  (isClickable: boolean): SxProps<Theme> =>
  ({ backrs, typography }) => ({
    backgroundColor: backrs.colors['Brand/50'],
    border: `1px solid ${backrs.colors['Brand/200']}`,
    '& .MuiChip-label': {
      color: backrs.colors['Brand/700'],
      ...typography['text-xs-medium'],
    },
    alignSelf: 'flex-start',
    cursor: isClickable ? 'pointer' : 'default',
    '&:hover': isClickable
      ? {
          backgroundColor: backrs.colors['Brand/100'],
        }
      : undefined,
  });
